import moment from 'moment'

function upperFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function formatTimeToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()
  return m.locale(locale).format('LT')
}

export function formatDateToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()

  const date = m.locale(locale).format('LL')
  return upperFirst(date)
}
